module.exports = __webpack_public_path__ + "static/media/main_marker.a9f67046.svg";